import { Directive, ViewContainerRef } from '@angular/core';

/**
 * Permet de referencé le conteneur du formulaire du noeud selectionné.
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[nodeFormHost]',
    standalone: true,
})
export class NodeFormDirective {
    /**
     * Constructeur.
     * @param viewContainerRef : Reference de la vue contenant cette directive.
     */
    constructor(public viewContainerRef: ViewContainerRef) {}
}
